import * as Yup from "yup";
import { useState } from "react";
import { useFormik, Form, FormikProvider } from "formik";
// material
import {
  Stack,
  TextField,
  IconButton,
  InputAdornment,
  Alert,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// component
import Iconify from "../../../components/Iconify";
//GRAHPQL
import { INICIAR_SESION } from "../../../graphql/usuarios";
import { useMutation } from "@apollo/client";
import { decodeToken, setToken, setMenuBar } from "../../../utils/token";
import useAuth from "../../../hooks/useAuth";
// ----------------------------------------------------------------------

export default function LoginForm() {
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState({ message: "", show: false });

  //Graphql
  const [iniciarSesion] = useMutation(INICIAR_SESION);
  const auth = useAuth();
  const { setUser, setSideBar } = auth;

  const LoginSchema = Yup.object().shape({
    username: Yup.string().required("El usuario es requerido"),
    password: Yup.string().required("La contraseña es requerida"),
  });

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: LoginSchema,
    onSubmit: async (datos) => {
      try {
        const { data } = await iniciarSesion({
          variables: {
            input: datos,
          },
        });
        const token = data.iniciarSesion.session;

        setMenuBar(JSON.stringify(data.iniciarSesion.MenuSideBar));
        setToken(token);
        setSideBar(JSON.stringify(data.iniciarSesion.MenuSideBar));
        setUser(decodeToken(token));
      } catch (error) {
        setErrorMsg({
          message: error.message,
          show: true,
        });
      }
    },
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } =
    formik;

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  return (
    <>
      <FormikProvider value={formik}>
        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
          <Stack spacing={3}>
            <TextField
              fullWidth
              autoComplete="username"
              type="username"
              label="Usuario"
              {...getFieldProps("username")}
              error={Boolean(touched.username && errors.username)}
              helperText={touched.username && errors.username}
            />

            <TextField
              fullWidth
              autoComplete="current-password"
              type={showPassword ? "text" : "password"}
              label="Contraseña"
              {...getFieldProps("password")}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleShowPassword} edge="end">
                      <Iconify
                        icon={
                          showPassword ? "eva:eye-fill" : "eva:eye-off-fill"
                        }
                      />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              error={Boolean(touched.password && errors.password)}
              helperText={touched.password && errors.password}
            />
          </Stack>

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ my: 2 }}
          >
            {errorMsg.show && (
              <Alert severity="error">{errorMsg.message}</Alert>
            )}
          </Stack>

          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Ingresar
          </LoadingButton>
        </Form>
      </FormikProvider>
    </>
  );
}
